// PLIK GENEROWANY przez scripts/cke-cs-exams.cjs - nie edytuj ręcznie.
// Struktura arkuszy z zasad oceniania CKE (bez treści zadań).
import { exam, t, type ExamSheet } from './types';

export const CS_EXAMS: ExamSheet[] = [
  exam({
    id: "inf-2605-PR",
    subjectId: 'cs',
    level: 'PR',
    kind: "main",
    date: "2026-05",
    era: 2024,
    minutes: 210,
    sheetUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2026/Informatyka/MINP-R0-100-A-2605-arkusz.pdf",
    keyUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2026/Informatyka/MINP-R0-100-2605-zasady.pdf",
    dataUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2026/Informatyka/Dane-NF-2605.zip",
    tasks: [
    t("1.1", 3, ["I.4","I+II.3","P.I.3"], ["cs-recursion","cs-analysis"]),
    t("1.2", 1, ["I.4","I+II.3","P.I.3","P.II.1"], ["cs-recursion","cs-analysis"]),
    t("1.3", 3, ["I.4","I+II.3","P.I.3","P.II.1"], ["cs-recursion","cs-analysis"]),
    t("2.1", 1, ["P.I.3","P.II.1"], ["cs-py-functions","cs-arrays","cs-files"]),
    t("2.2", 4, ["I.4","I+II.3","P.I.3","P.II.1"], ["cs-analysis"]),
    t("3.1", 2, ["I.4","I.5","I.7","I+II.1","P.I.2","P.II.1"], ["cs-representation","cs-analysis"]),
    t("3.2", 3, ["P.II.1","I.2","II.1","II.2"], ["cs-py-functions","cs-arrays","cs-files"]),
    t("3.3", 4, ["P.II.1"], ["cs-py-functions","cs-arrays","cs-files"]),
    t("4.1", 1, ["P.I.3","P.I.2","P.II.1"], ["cs-py-functions","cs-arrays","cs-files"]),
    t("4.2", 2, ["I.4","II.2"], ["cs-py-functions","cs-arrays","cs-files"]),
    t("4.3", 2, ["I.4","II.2","P.I.2","P.II.1"], ["cs-py-functions","cs-arrays","cs-files"]),
    t("4.4", 3, ["I.4","II.2","P.I.2","P.II.1"], ["cs-py-functions","cs-arrays","cs-files"]),
    t("5", 2, ["I.5"], ["cs-bases"]),
    t("6", 1, [], ["cs-networks"]),
    t("7.1", 3, ["II.3","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("7.2", 2, ["II.3","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("7.3", 2, ["II.3","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("7.4", 2, ["II.3","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("8.1", 1, ["II.3","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("8.2", 2, ["II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("8.3", 2, ["II.3","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("8.4", 2, ["II.3","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("8.5", 2, ["II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    ],
  }),
  exam({
    id: "inf-2505-PR",
    subjectId: 'cs',
    level: 'PR',
    kind: "main",
    date: "2025-05",
    era: 2024,
    minutes: 210,
    sheetUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2025/Informatyka/MINP-R0-100-A-2505-arkusz.pdf",
    keyUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2025/zasady_oceniania/MINP-R0-100-2505-zasady.pdf",
    dataUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2025/Informatyka/Dane-NF-2505.zip",
    tasks: [
    t("1.1", 3, ["I.4","I+II.3","P.I.3"], ["cs-recursion","cs-search-sort"]),
    t("1.2", 2, ["I.4","I+II.3","P.I.3","P.II.1"], ["cs-recursion","cs-search-sort"]),
    t("1.3", 4, ["I.2","I+II.1","P.II.1"], ["cs-recursion","cs-search-sort"]),
    t("2.1", 2, ["I.4","I.5","I.7","I+II.1","P.I.2"], ["cs-strings","cs-analysis","cs-security"]),
    t("2.2", 4, ["P.II.1","I.2","II.1","II.2"], ["cs-py-functions","cs-arrays","cs-files"]),
    t("2.3", 2, ["P.I.2","P.II.1","I.2","II.1","II.2"], ["cs-bases"]),
    t("2.4", 3, ["P.I.2","P.II.1","I.2","II.1","II.2"], ["cs-bases"]),
    t("3.1", 2, ["P.I.3","P.I.2","P.II.1"], ["cs-py-functions","cs-arrays","cs-files"]),
    t("3.2", 4, ["I.4","II.2","P.I.2","P.II.1"], ["cs-py-functions","cs-arrays","cs-files"]),
    t("4", 1, ["P.V.3","P.V.4"], ["cs-security"]),
    t("5", 2, ["P.I.2","I+II.2"], ["cs-bases"]),
    t("6.1", 2, ["II.3","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("6.2", 1, ["II.3","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("6.3", 2, ["II.3","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("6.4", 3, ["II.3","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("6.5", 3, ["II.3","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("7.1", 2, ["II.3","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("7.2", 2, ["II.3","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("7.3", 2, ["II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("7.4", 2, ["II.3","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("7.5", 2, ["II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    ],
  }),
  exam({
    id: "inf-2412-PR",
    subjectId: 'cs',
    level: 'PR',
    kind: "diagnostic",
    date: "2024-12",
    era: 2024,
    minutes: 210,
    sheetUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2015/Probny/2024/Informatyka/MINP-R0-100-A-2412-arkusz.pdf",
    keyUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2015/Probny/2024/Informatyka/MINP-R0-100-200-300-400-660-2412-zasady.pdf",
    dataUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2015/Probny/2024/Informatyka/Dane-2412.zip",
    tasks: [
    t("1.1", 2, ["I.4","P.I.2","P.I.3"], ["cs-numbers","cs-bases","cs-analysis"]),
    t("1.2", 3, ["I.4","I.5","I.7","I+II.1","P.I.2","P.II.1"], ["cs-bases","cs-analysis"]),
    t("2.1", 3, ["I.1","I.4","P.I.2","P.II.1"], ["cs-recursion","cs-numbers","cs-bases","cs-binary-search","cs-search-sort","cs-greedy","cs-analysis"]),
    t("2.2", 2, ["I.1","I.4","P.I.2","P.II.1"], ["cs-recursion","cs-numbers","cs-bases","cs-binary-search","cs-search-sort","cs-greedy","cs-analysis"]),
    t("3.1", 2, ["I.4","I.5","I.7","I+II.1","II.1","P.I.2","P.II.1"], ["cs-numbers","cs-gcd","cs-bases","cs-analysis"]),
    t("3.2", 3, ["I.4","I.5","I.7","I+II.1","I+II.2","II.1","P.I.2","P.II.1"], ["cs-numbers","cs-gcd","cs-bases","cs-analysis"]),
    t("3.3", 3, ["II.1","P.I.2"], ["cs-numbers","cs-gcd","cs-bases"]),
    t("4.1", 2, ["I.4","I.5","I+II.1","II.1","P.II.1"], ["cs-analysis"]),
    t("4.2", 2, ["I.4","I.5","I+II.1","I+II.2","II.1","P.II.1"], ["cs-subseq","cs-analysis"]),
    t("4.3", 4, ["I.4","I.5","I+II.1","I+II.2","II.1","II.2","P.II.1"], ["cs-subseq","cs-analysis"]),
    t("5", 1, ["V.1","V.2","P.V.3"], ["cs-security"]),
    t("6", 2, ["I+II.2"], ["cs-bases"]),
    t("7.1", 2, ["II.3","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("7.2", 3, ["II.3","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("7.3", 3, ["II.3","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("7.4", 3, ["II.3","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("8.1", 2, ["II.3","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("8.2", 2, ["II.3","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("8.3", 2, ["II.3","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("8.4", 2, ["II.3","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("8.5", 2, ["II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join","cs-search-sort"]),
    ],
  }),
  exam({
    id: "inf-2405-PR",
    subjectId: 'cs',
    level: 'PR',
    kind: "main",
    date: "2024-05",
    era: 2018,
    minutes: 210,
    sheetUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2024/Informatyka/MINP-R0-100-A-2405-arkusz.pdf",
    keyUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2024/Informatyka/MINP-R0-100-2405-zasady.pdf",
    dataUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2024/Informatyka/Dane-NF-2405.zip",
    tasks: [
    t("1.1", 2, ["I.2","P.I.4","P.I.5"], ["cs-analysis"]),
    t("1.2", 2, ["I.2","P.I.4","P.I.5","P.II.1"], ["cs-analysis"]),
    t("1.3", 1, ["I.2","P.I.4","P.I.5","P.II.1"], ["cs-analysis"]),
    t("2.1", 2, ["P.I.1","P.I.2","P.I.4","P.II.1"], ["cs-bases","cs-analysis"]),
    t("2.2", 1, ["I.2","I.5","P.I.2","P.I.4","P.II.1"], ["cs-bases","cs-representation","cs-analysis"]),
    t("3.1", 3, ["I.2","I.3","I.5","I+II.1"], ["cs-bases","cs-representation","cs-analysis"]),
    t("3.2", 3, ["P.II.1","I.2","II.1","II.2","II.3"], ["cs-py-functions","cs-arrays","cs-files"]),
    t("3.3", 4, ["P.II.1","I.2","II.1"], ["cs-py-functions","cs-arrays","cs-files"]),
    t("4.1", 2, ["P.I.5","P.I.2","P.II.1"], ["cs-py-functions","cs-arrays","cs-files"]),
    t("4.2", 2, ["I.2","II.3","P.I.2","P.II.1"], ["cs-search-sort"]),
    t("4.3", 3, ["I.2","II.3","P.I.2","P.II.1"], ["cs-numbers","cs-subseq"]),
    t("4.4", 3, ["I.2","II.3","P.I.2","P.II.1"], ["cs-numbers","cs-subseq"]),
    t("5", 1, [], ["cs-networks"]),
    t("6", 2, [], ["cs-bases"]),
    t("7.1", 2, ["II.4","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("7.2", 2, ["II.4","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("7.3", 3, ["II.4","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("7.4", 3, ["II.4","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("8.1", 2, ["II.4","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("8.2", 2, ["II.4","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("8.3", 3, ["II.4"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join","cs-search-sort"]),
    t("8.4", 2, ["II.4"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    ],
  }),
  exam({
    id: "inf-2305-PR",
    subjectId: 'cs',
    level: 'PR',
    kind: "main",
    date: "2023-05",
    era: 2018,
    minutes: 210,
    sheetUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2023/Informatyka/MINP-R0-100-2305.pdf",
    keyUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2023/Informatyka/MINP-R0-100-2305-zasady.pdf",
    dataUrl: "https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/Arkusze_egzaminacyjne/2023/Informatyka/Dane_2305.zip",
    tasks: [
    t("1.1", 2, ["I.2","P.I.3","P.I.5"], ["cs-recursion","cs-greedy","cs-analysis"]),
    t("1.2", 3, ["I.2","P.I.3","P.I.5"], ["cs-recursion","cs-greedy","cs-analysis"]),
    t("1.3", 2, ["I.2","P.I.3","P.I.5"], ["cs-recursion","cs-greedy","cs-analysis"]),
    t("2.1", 3, ["I.2","I.3","I.5","I+II.1","P.I.2"], ["cs-bases","cs-representation","cs-analysis"]),
    t("2.2", 2, ["I.2","I.5","II.2","II.3","P.I.2","P.II.1"], ["cs-bases","cs-representation"]),
    t("2.3", 2, ["I.2","I.5","II.2","II.3","P.I.2"], ["cs-bases","cs-representation"]),
    t("2.4", 1, ["I.2","I.5","P.I.2"], ["cs-bases","cs-representation"]),
    t("2.5", 3, ["I.2","I.5","II.2","II.3","P.I.2","P.II.1"], ["cs-bases","cs-representation"]),
    t("3.1", 2, ["I.2","II.3","P.I.2","P.II.1","I+II.2"], ["cs-subseq"]),
    t("3.2", 3, ["I.2","II.3","P.I.2","P.II.1"], ["cs-subseq"]),
    t("3.3", 3, ["I.2","II.3","P.I.2","P.II.1","I+II.2"], ["cs-subseq"]),
    t("3.4", 2, ["I.2","II.3","P.I.2","P.II.1","I+II.2"], ["cs-subseq"]),
    t("4", 1, ["P.V.3","V.1","V.2"], ["cs-security"]),
    t("5", 1, ["P.I.2","I.5"], ["cs-bases","cs-representation"]),
    t("6.1", 3, ["II.4","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("6.2", 1, ["II.4","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("6.3", 3, ["II.4","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("6.4", 3, ["II.4","P.II.3"], ["cs-sheet-formulas","cs-sheet-analysis"]),
    t("7.1", 1, ["II.4","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("7.2", 2, ["II.4"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("7.3", 2, ["II.4","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("7.4", 3, ["II.4","P.II.3"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    t("7.5", 2, ["II.4"], ["cs-sql-select","cs-sql-aggregate","cs-sql-join"]),
    ],
  }),
];
